import { GET_MENU, UPDATE_MENU_AGREEMENTS } from './../constants';
import { handleActions } from "redux-actions"

export const menu  = handleActions(
  {
    [ GET_MENU ]: (state, action) => action.payload,
    [ UPDATE_MENU_AGREEMENTS ]: (state, action) => {
      // console.log('UPDATE_MENU_AGREEMENTS ', action)
      let menuResult = state
      const indexServices = menuResult.findIndex((element) => element.text === 'Pago de servicios')
      const { type, name, state: stateAgr } = action.payload
      let index = null
      switch (type) {
        case 1:
          index = 2
          break;
        case 2:
          index = 3
          break;
        case 3:
          index = 4
          break;
        case 4:
          index = 5
          break;
        case 5:
          index = 6
          break;
        default:
          break;
      }
      const indexServicesItem = menuResult[indexServices].subItems[index].subItemSecundario.findIndex((element) => element.sstext === name)
      menuResult[indexServices].subItems[index].subItemSecundario[indexServicesItem].state = stateAgr
      return menuResult
    }
  }, []
)